// extracted by mini-css-extract-plugin
export default {"form-group":"LeftNavigation_form-group__o8yod","container":"LeftNavigation_container__8s3I2","teams":"LeftNavigation_teams__n1Qo+","drawer":"LeftNavigation_drawer__BO4JC"};